// Scope: summarizes the currently selected MERN notes collection.

import React from "react";

const Dashboard = ({ notes, activeUsers, view }) => (
    <div className="dashboard">
        {typeof activeUsers !== "undefined" && (
            <div className="counter counter-active-users">
                <span className="counter-label">Active Users:</span>
                <span className="counter-value counter-active-value">{activeUsers}</span>
            </div>
        )}
        <div className="counter">
            <span className="counter-label">
                {view === "deleted" ? "Archived Notes" : "Active Notes"}:
            </span>
            <span className="counter-value">{notes.length}</span>
        </div>
    </div>
);

export default Dashboard;
